<template>
  <div>
    <span class="block">{{ $formatDateTime(value).date }}</span>
    <span :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-60']">{{
      $formatDateTime(value).time
    }}</span>
  </div>
</template>

<script>
export default {
  name: "FallbackDateTime",
  props: {
    mode: String,
    value: String,
  },
};
</script>
